import React, { MouseEventHandler } from 'react';
import { Button } from '@/Components/shadcn/button';
import { ImageCropStrings } from './ImageCropUtils';
import { ImageCropContextProps } from './ImageCropContext';
import { Spinner } from '../shadcn/spinner';

export interface ImageCropDialogActionsProps
    extends Pick<ImageCropStrings, 'uploadButtonText'>, Pick<ImageCropContextProps, 'processing'> {
    onUpload: MouseEventHandler<HTMLButtonElement>;
}

export const ImageCropDialogActions = ({
    onUpload,
    processing,
    uploadButtonText,
}: ImageCropDialogActionsProps): React.JSX.Element => {
    return (
        <div className="mt-6 flex flex-row justify-end">
            <Button type="button" size="lg" data-cy="ImageCropUploadButton" disabled={processing} onClick={onUpload}>
                {processing && <Spinner className="mr-2 size-4" />}
                {uploadButtonText}
            </Button>
        </div>
    );
};
